import React, {Component} from 'react';
import {Alert, Checkbox, createTheme, Dialog, DialogContent, DialogTitle, FormControlLabel, FormGroup, IconButton, Snackbar, ThemeProvider} from "@mui/material";
import {Close, ArrowCircleDown} from "@mui/icons-material";
import {DataGrid} from "@mui/x-data-grid";
import {CSVLink} from "react-csv";
import {ReactComponent as Sparql} from "../../assets/icons/sparql.svg"
import { nanoid } from 'nanoid'


const darkTheme = createTheme({
    palette: {
        mode: 'dark',
    },
});

class ResultsDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openDialog: false,
            theDataGridRef: React.createRef(),
            rows: [],
            columns: [],
            idKey: undefined,
            resultsContent: undefined,
            currentSparqlQuery: "",
            showNotification: false,
            notificationMessage: "",
            hyponyms : false,
            ballRef : undefined
        }
    }

    openMe = (results, columns, key, sparql,ballRef) => {
        let me = this
        this.setState({openDialog: true, columns: columns, rows: results, idKey: key, currentSparqlQuery: sparql, ballRef: ballRef}, () => {
            // console.log(me.state)
        });
    }

    closeMe = () => {
        this.setState({openDialog: false});
    }
    closeNotification = () => {
        this.setState({showNotification: false})
    };
    rowSelected = (data) => {
        console.log("result click row");
        // console.log(data);
        let url = data[0]
        if (data.colDef.useCellData) {
            window.open(data.row[data.colDef.cellData].split("")[0], '_blank').focus();
        } else {
            window.open(data.id.split("")[0], '_blank').focus();
        }
        // if (url.includes("lila-erc.eu/data/id/lemma/")){
        //     console.log(url);
        // }else {

        //}
    }

    copySparqlInClipBoard() {
        if (this.state.currentSparqlQuery.length > 0) {
            console.log("copy");
            let el = document.createElement('textarea');
            // Set value (string to be copied)
            el.value = this.state.currentSparqlQuery
            // Set non-editable to avoid focus and move outside of view
            el.setAttribute('readonly', '');
            el.style = {position: 'absolute', left: '-9999px'};
            document.body.appendChild(el);
            // Select text inside element
            el.select();
            // Copy text to clipboard
            document.execCommand('copy');
            // Remove temporary element
            document.body.removeChild(el);

            console.log("copied on clipboard")
            this.setState({notificationMessage: "Sparql query has been copied to clipboard"}, () => {
                this.setState({showNotification: true})
            })
        }
    }


    copySparqlInClipBoard() {
        let me = this
        if (this.state.currentSparqlQuery.length > 0) {
            console.log(this.state.currentSparqlQuery)
            console.log("copy");
            let el = document.createElement('textarea');
            // Set value (string to be copied)
            el.value = this.state.currentSparqlQuery
            // Set non-editable to avoid focus and move outside of view
            el.setAttribute('readonly', '');
            el.style = {position: 'absolute', left: '-9999px'};
            document.body.appendChild(el);
            // Select text inside element
            el.select();
            // Copy text to clipboard
            document.execCommand('copy');
            // Remove temporary element
            document.body.removeChild(el);


            this.setState({notificationMessage: "Sparql query has been copied to clipboard"}, () => {
                me.setState({showNotification: true},()=>{
                    me.setState({showNotification: false})
                })
            })
        }
    }
    reload = () => {
        console.log("reload")
    }
    changeWnRelMode = () => {
        let mode = !this.state.hyponyms
        let me = this
        this.setState({hyponyms: mode},()=>{
        //    console.log(me.state.ballRef)
            me.state.ballRef.current.setHyponymsAndRedoQuery(mode);
        })
    }
    render() {
       // console.log(this.state.rows)
        return (

            <div>
                <ThemeProvider theme={darkTheme}>
                    <Dialog
                        // selectedValue={selectedValue}
                        fullWidth
                        maxWidth={"md"}
                        open={this.state.openDialog}
                        onClose={this.closeMe}
                    >
                        <DialogTitle>Results

                            <IconButton
                                aria-label="sparql"
                                style={{
                                    position: 'absolute',
                                    right: 100,
                                    top: 10,
                                    color: (theme) => theme.palette.grey[500],
                                }}
                            >
                                <Sparql onClick={() => {
                                    this.copySparqlInClipBoard()
                                }} style={{width: "18px", cursor: "pointer", fill: "#ffffff"}}/>
                                {/*<CSVLink data={this.state.rows} style={{color:"#ffffff"}} filename={"LiLa_query_data_download.csv"}>*/}
                                {/*    <ArrowCircleDown/>*/}
                                {/*</CSVLink>*/}
                            </IconButton>
                            <IconButton
                                aria-label="download"
                                style={{
                                    position: 'absolute',
                                    right: 50,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500],
                                }}
                            >
                                <CSVLink data={this.state.rows} style={{color: "#ffffff"}} filename={"LiLa_query_data_download.csv"}>
                                    <ArrowCircleDown/>
                                </CSVLink>
                            </IconButton>

                            <IconButton
                                aria-label="close"
                                onClick={this.closeMe}
                                style={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500],
                                }}
                            >
                                <Close/>
                            </IconButton>
                        </DialogTitle>
                        {this.state.idKey == "wnsyns" ?
                            <FormGroup style={{marginLeft: "15px"}}>
                                <FormControlLabel control={<Checkbox checked={this.state.hyponyms} onClick={() => this.changeWnRelMode()}/>} label="Get hyponyms"/>
                            </FormGroup> : ""}
                        <DialogContent>
                            <div style={{height: 400, width: 'auto'}}>
                                <DataGrid
                                    ref={this.state.theDataGridRef}
                                    rows={this.state.rows}
                                    columns={this.state.columns}
                                    getRowId={(row) => row[this.state.idKey]+""+nanoid()}
                                    rowsPerPageOptions={[]}

                                    pageSize={100}
                                    //checkboxSelection
                                    // disableSelectionOnClick
                                    onCellClick={(data) => this.rowSelected(data)}

                                    // onSelectionModelChange={(data) => this.rowSelected(data)}
                                    //selectionModel={this.state.selectedRows}
                                />
                            </div>
                        </DialogContent>

                    </Dialog>

                </ThemeProvider>
                <Snackbar
                    style={{zIndex: 10000}}
                    anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                    open={this.state.showNotification}
                    onClose={this.closeNotification}
                    autoHideDuration={1000}>
                    <Alert severity="success">
                        {this.state.notificationMessage}
                    </Alert>
                </Snackbar>
            </div>
        );
    }
}


export default ResultsDialog;
